__turbopack_context__.v({
  "className": "el_messiri_40940ca6-module__WhfENq__className",
});
